var CookieUpdater = /** @class */ (function () {
    function CookieUpdater() {
    }
    CookieUpdater.prototype.deleteCookie = function (name) {
        document.cookie = name + "=; expires=Thu, 01 Jan 1970 00:00:01 GMT;";
    };
    return CookieUpdater;
}());
export { CookieUpdater };
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiY29va2llLXVwZGF0ZXIuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyJjb29raWUtdXBkYXRlci50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFBQTtJQUFBO0lBSUEsQ0FBQztJQUhVLG9DQUFZLEdBQW5CLFVBQW9CLElBQVk7UUFDNUIsUUFBUSxDQUFDLE1BQU0sR0FBTSxJQUFJLDhDQUEyQyxDQUFDO0lBQ3pFLENBQUM7SUFDTCxvQkFBQztBQUFELENBQUMsQUFKRCxJQUlDIn0=